import { render } from "./CurrencyInput.vue?vue&type=template&id=bd5247a8&scoped=true"
import script from "./CurrencyInput.vue?vue&type=script&lang=js"
export * from "./CurrencyInput.vue?vue&type=script&lang=js"

import "./CurrencyInput.vue?vue&type=style&index=0&id=bd5247a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd5247a8"]])

export default __exports__